import { render, staticRenderFns } from "./LgFinderPageTipoModalidade.vue?vue&type=template&id=78ed93d0"
import script from "./LgFinderPageTipoModalidade.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoModalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports